// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanDelete } from "./hook";

export type CanDeleteProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanDelete({ children, fallback, scope }: CanDeleteProps) {
  const canDoAction = useCanDelete(scope);
  return <>{canDoAction ? children : fallback}</>;
}
